import { nextTick, ref, watch, type Ref } from "vue";
import { defilerDansDemoAccueil } from "~/utils/demoAccueil";

/**
 * Hauteur cachée par le header flottant (pilule AppHeader) en haut de l'écran,
 * plus un peu d'air : la ligne des étapes s'arrête juste dessous.
 */
const HAUT_SOUS_HEADER = 120;

/**
 * Remonte en douceur jusqu'au haut de la carte des étapes quand on l'a
 * dépassé. Ne bouge pas si ce haut est déjà visible : pas de saccade, et
 * jamais de descente. Dans la démo de la home, défile dans la démo seulement.
 */
export function remonterAuDebutDeLEtape(el: HTMLElement | null | undefined) {
  if (typeof window === "undefined" || !el) return;
  if (defilerDansDemoAccueil(el, 16)) return;
  const haut = el.getBoundingClientRect().top;
  if (haut >= HAUT_SOUS_HEADER - 10) return;
  window.scrollTo({ top: Math.max(0, haut + window.scrollY - HAUT_SOUS_HEADER), behavior: "smooth" });
}

/**
 * Tunnels adhésion / billetterie : à chaque changement d'étape (« Suivant »,
 * retour, clic sur un onglet), on revoit la nouvelle étape depuis son début —
 * ex. tarifs choisis tout en bas de l'étape 1, puis « Suivant ».
 * Karim 2026-06-27 / 2026-10-21.
 *
 * Renvoie la ref à poser sur la carte des étapes (`ref="wizardTopRef"`).
 */
export function remonterAChaqueEtape(etape: Ref<number>): Ref<HTMLElement | null> {
  const carte = ref<HTMLElement | null>(null);
  watch(etape, () => void nextTick(() => remonterAuDebutDeLEtape(carte.value)));
  return carte;
}
